"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdate = useUpdate;
var _react = require("react");
var _lodash = require("lodash");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function useUpdate(_ref) {
  var update = _ref.update,
    _ref$handleSuccess = _ref.handleSuccess,
    handleSuccess = _ref$handleSuccess === void 0 ? _lodash.noop : _ref$handleSuccess,
    _ref$handleErrors = _ref.handleErrors,
    handleErrors = _ref$handleErrors === void 0 ? _lodash.noop : _ref$handleErrors,
    _ref$handleStarted = _ref.handleStarted,
    handleStarted = _ref$handleStarted === void 0 ? _lodash.noop : _ref$handleStarted;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    processing = _useState2[0],
    setProcessing = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    res = _useState4[0],
    setRes = _useState4[1];
  var handleSubmit = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var _res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleStarted();
              setProcessing(true);
              _context.prev = 2;
              _context.next = 5;
              return update(data);
            case 5:
              _res = _context.sent;
              handleSuccess(_res);
              setRes(_res);
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              handleErrors(_context.t0);
            case 14:
              _context.prev = 14;
              setProcessing(false);
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 14, 17]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [update, handleStarted, handleSuccess, handleErrors, setProcessing]);
  return {
    data: res,
    handleSubmit: handleSubmit,
    processing: processing
  };
}